import { ref, resolveComponent, createBlock, openBlock, unref, withCtx, createVNode, isRef, createElementVNode, createCommentVNode, toDisplayString, createTextVNode } from "vue";
import _sfc_main$1 from "../Base/LogViewer.vue.js";
import "../../plugins/apollo.js";
import "lodash-es";
import "moment";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import { useI18n } from "../../plugins/i18n.js";
import "../../assets/e94e4817134d7c25.png";
import "../../assets/5341da3ffbec0137.png";
import "../../assets/01f50022317dccd7.png";
import "axios";
import "vue-router";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css                     */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import "vuetify/components/VGrid";
import "../Base/index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                      */
import { VChip } from "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import "../../graphql/system-settings.js";
import "tiny-emitter/instance";
/* empty css                             */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/entity.js";
import "../../graphql/lookups.js";
/* empty css                       */
import "vuetify/components";
/* empty css                             */
import { SYSTEM_EVENTS_ONE_LEVEL } from "../../graphql/system-events.js";
import { SystemEventLevelArray, getSystemEventLevelById } from "../../constants/SystemEventLevel.js";
/* empty css                                        */
/* empty css                         */
import "vuetify/components/VTooltip";
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
/* empty css                            */
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
const _hoisted_1 = { class: "d-flex align-center g-2" };
const _hoisted_2 = { class: "font-weight-bold" };
const _hoisted_3 = { class: "d-flex flex-column g-4" };
const _sfc_main = {
  __name: "SystemEventsSection",
  setup(__props) {
    const { t } = useI18n();
    const headers = ref([
      {
        key: "serviceName",
        title: t(
          "components.admin.system_events.SystemEventsSection.labels.service_name"
        )
      },
      {
        key: "createdOn",
        title: t(
          "components.admin.system_events.SystemEventsSection.labels.created_on"
        )
      },
      {
        key: "levelInTree",
        title: t(
          "components.admin.system_events.SystemEventsSection.labels.level_in_tree"
        )
      },
      {
        key: "contact.name",
        title: t(
          "components.admin.system_events.SystemEventsSection.labels.contact"
        )
      },
      {
        key: "duration",
        title: t(
          "components.admin.system_events.SystemEventsSection.labels.duration"
        )
      }
    ]);
    const filterFields = ref([
      {
        key: "createdOn",
        type: "date-range",
        title: t(
          "components.admin.system_events.SystemEventsSection.labels.created_on"
        ),
        icon: "mdi-calendar"
      },
      {
        key: "levelInTree",
        type: "lookup",
        title: t(
          "components.admin.system_events.SystemEventsSection.labels.level"
        ),
        icon: "mdi-alert-octagon",
        items: SystemEventLevelArray
      }
    ]);
    const getItemLevel = (item) => {
      return item.__level ? item.level : item.levelInTree;
    };
    const selectedSystemEvent = ref(null);
    const systemEventCardVisible = ref(false);
    const openSystemEventCard = (_, { item }) => {
      selectedSystemEvent.value = item;
      systemEventCardVisible.value = true;
    };
    return (_ctx, _cache) => {
      const _component_b_btn = resolveComponent("b-btn");
      const _component_b_icon = resolveComponent("b-icon");
      const _component_b_bottom_card = resolveComponent("b-bottom-card");
      const _component_b_section = resolveComponent("b-section");
      return openBlock(), createBlock(_component_b_section, {
        header: _ctx.$t("components.admin.system_events.SystemEventsSection.header"),
        headers: unref(headers),
        query: unref(SYSTEM_EVENTS_ONE_LEVEL),
        "search-field": "serviceName,tags",
        "filter-fields-compact": unref(filterFields),
        "default-sort-by": [{ key: "createdOn", order: "desc" }],
        "multi-sort": true,
        hierarchical: {
          displayColumnName: "serviceName",
          levelQuery: unref(SYSTEM_EVENTS_ONE_LEVEL),
          levelSortBy: [{ key: "createdOn", order: "asc" }]
        },
        "onClick:row": openSystemEventCard
      }, {
        "header-actions": withCtx(({ reload }) => [
          createVNode(_component_b_btn, {
            preset: "moduleReload",
            onClick: reload
          }, null, 8, ["onClick"])
        ]),
        "item.createdOn": withCtx(({ item }) => [
          createTextVNode(toDisplayString(_ctx.$moment(item.createdOn).format("DD.MM.YYYY HH:mm:ss")), 1)
        ]),
        "item.duration": withCtx(({ item }) => [
          createTextVNode(toDisplayString(item.duration ? `${(item.duration / 1e3).toFixed(3)} сек.` : "--"), 1)
        ]),
        "item.levelInTree": withCtx(({ item }) => [
          createElementVNode("div", _hoisted_1, [
            item.level || item.levelInTree ? (openBlock(), createBlock(VChip, {
              key: 0,
              variant: "flat",
              density: "compact",
              color: unref(getSystemEventLevelById)(getItemLevel(item)).color
            }, {
              default: withCtx(() => [
                createElementVNode("span", _hoisted_2, toDisplayString(getItemLevel(item)), 1)
              ]),
              _: 2
            }, 1032, ["color"])) : createCommentVNode("", true),
            item.error ? (openBlock(), createBlock(_component_b_icon, {
              key: 1,
              icon: "mdi-alert-octagon",
              color: unref(getSystemEventLevelById)(getItemLevel(item)).color,
              size: 20
            }, null, 8, ["color"])) : createCommentVNode("", true)
          ])
        ]),
        "bottom-content": withCtx(() => {
          var _a;
          return [
            createVNode(_component_b_bottom_card, {
              modelValue: unref(systemEventCardVisible),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(systemEventCardVisible) ? systemEventCardVisible.value = $event : null),
              title: (_a = unref(selectedSystemEvent)) == null ? void 0 : _a.serviceName
            }, {
              default: withCtx(() => {
                var _a2, _b, _c, _d;
                return [
                  createElementVNode("div", _hoisted_3, [
                    ((_a2 = unref(selectedSystemEvent)) == null ? void 0 : _a2.error) ? (openBlock(), createBlock(_sfc_main$1, {
                      key: 0,
                      data: (_b = unref(selectedSystemEvent)) == null ? void 0 : _b.error,
                      error: true
                    }, null, 8, ["data"])) : createCommentVNode("", true),
                    ((_c = unref(selectedSystemEvent)) == null ? void 0 : _c.details) ? (openBlock(), createBlock(_sfc_main$1, {
                      key: 1,
                      data: (_d = unref(selectedSystemEvent)) == null ? void 0 : _d.details
                    }, null, 8, ["data"])) : createCommentVNode("", true)
                  ])
                ];
              }),
              _: 1
            }, 8, ["modelValue", "title"])
          ];
        }),
        _: 1
      }, 8, ["header", "headers", "query", "filter-fields-compact", "hierarchical"]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
